export default "__VITE_ASSET__5a02db47__"